/**
 * MessageTemplate コンポーネント
 *
 * メッセージテンプレートの一覧を表示するコンポーネント。
 * テンプレートの種類を選択し、新規作成ボタンを提供します。
 *
 * @file メッセージテンプレート一覧
 * @date 2025/06/26
 */

import React, { useState } from 'react';
import { Button, Flex, Typography, Card } from 'antd';
import * as icon from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { Radio, Space } from 'antd';
import { MessageTemplateTable } from 'src/components/model/messageTemplate/table';
import { useMessageTemplateList } from 'src/usecases/messageTemplate/reader';

/**
 * MessageTemplate コンポーネント
 *
 * メッセージテンプレートの一覧を表示するコンポーネント。
 *
 * @returns JSX.Element
 */
export const MessageTemplate: React.FC = () => {
  // ナビゲーションフック
  const navigate = useNavigate();

  // 新規作成ボタンのハンドラ
  const onClickCreate = React.useCallback(() => navigate('new'), [navigate]);

  // 選択された使用目的の状態
  const [selectedUsage, setSelectedUsage] = useState<'directMessage' | 'broadcast'>('directMessage');

  // メッセージテンプレートのリストを取得
  const values = useMessageTemplateList();

  return (
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      <Radio.Group
        value={selectedUsage}
        onChange={(e) => setSelectedUsage(e.target.value)}
        style={{ marginBottom: 16 }}
      >
        <Radio.Button value="directMessage">DM用テンプレート</Radio.Button>
        <Radio.Button value="broadcast">配信用テンプレート</Radio.Button>
      </Radio.Group>
      <Card style={{ height: '10%' }}>
        <Flex justify="space-between" align="middle">
          <Typography.Title level={4} style={{ alignSelf: 'center' }}>
            テンプレート一覧
          </Typography.Title>
          <Button
            type="primary"
            icon={<icon.PlusOutlined />}
            onClick={onClickCreate}
          >
            新規作成
          </Button>
        </Flex>
      </Card>
      <div style={{ height: '15px' }} />
      <MessageTemplateTable
          messageTemplates={values.data?.messageTemplates ?? []}
          usage={selectedUsage}
      />
    </Space>
  );
};

export default MessageTemplate;